import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({

    benefit: {
        marginTop: '30px',
        marginBottom: '30px',
        maxWidth: '350px',
        marginLeft: 'auto',
        marginRight: 'auto',
        '& p': {
            color: '#555',
            '@media screen and (max-width: 768px)': {
                fontSize: '14px',
            },
            '@media screen and (max-width: 480px)': {
                fontSize: '12px',
            },
            '@media screen and (max-width: 380px)': {
                fontSize: '11px',
            },
        },
        '& h4': {
            '@media screen and (max-width: 768px)': {
                fontSize: '20px',
            },
            '@media screen and (max-width: 480px)': {
                fontSize: '16px',
            },
        },

        '@media screen and (max-width: 768px)': {
            marginBottom: '20px',
        },

        '@media screen and (max-width: 480px)': {
            marginTop: '15px',
            marginBottom: '15px',
        },
    },

    benefitImg: {
        padding: '20px',
        borderRadius: '25px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80px',
        width: '80px',
        minHeight: '80px',
        minWidth: '80px',
        marginBottom: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxShadow: '0 0 10px rgba(255, 255, 255, 0.5)',
        '&.color1': {
            backgroundColor: '#ffd25a',
        },
    
        '&.color2': {
            backgroundColor: '#161032',
        },
    
        '&.color3': {
            backgroundColor: '#e67a8d',
        },
    
        '&.color4': {
            backgroundColor: '#7989ef',
        },
    
        '&.color5': {
            backgroundColor: '#17B890',
        },

        '&.color6': {
            backgroundColor: '#60c1dc',
        },
    
        '& img': {
            maxWidth: '100%',
            '@media screen and (max-width: 768px)': {
                maxHeight: '50px',
            },
            '@media screen and (max-width: 480px)': {
                maxHeight: '30px',
            },
        },
        '@media screen and (max-width: 480px)': {
            height: '70px',
            width: '70px',
            minHeight: '70px',
            minWidth: '70px',
            padding: '10px',
            borderRadius: '20px',
        },
    },
});

function ProgramBenefitsItem(props) {

    var classes = useStyles()

    return (
        <div className={classes.benefit}>
            <div className={classes.benefitImg + " " + props.colorClass}>
                <img src={props.img} alt=""/>
            </div>
            <h4>{props.title}</h4>
            <p>{props.subtitle}</p>
        </div>
    )
}

export default ProgramBenefitsItem
